import Vue from 'vue'
import Vuex from 'vuex'
import mockBackend from './MockBackend'
import realBackend from './Backend'

let backend = (process.env.NODE_ENV === 'development' && process.env.VUE_APP_MODE === 'mock')
  ? mockBackend : realBackend

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    store: backend
  }
})
